<template>
    <v-container fluid>
        <v-row dense>
            <v-col>
                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="productData"
                    :items-per-page="20"
                    :footer-props="{
                        'items-per-page-options': [20, 50, 100, 200, -1],
                    }"
                    item-key="id"
                    show-select
                    single-select
                    class="elevation-1"
                    :loading="loading"
                    loading-text="Caricamento in corso..."
                    calculate-widths
                    dense
                >
                    <template v-slot:top>
                        <v-toolbar flat>
                            <v-toolbar-title
                                >Sincronizzazione con Shopify</v-toolbar-title
                            >
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-checkbox
                                v-model="formula_magica"
                                label="Formula Magica"
                                true-value="1"
                                false-value="0"
                                @change="onChangeFilters"
                                hide-details
                                class="mt-0"
                            ></v-checkbox>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="success"
                                dark
                                small
                                class="mr-4"
                                @click="exportCSV"
                            >
                                <v-icon left>mdi-download</v-icon>
                                Esporta CSV
                            </v-btn>
                        </v-toolbar>
                    </template>
                    <template v-slot:body.prepend>
                        <tr>
                            <td>
                                <v-checkbox
                                    v-model="filters.isSelected"
                                    @change="selectedChangeFilter()"
                                    :true-value="1"
                                    :false-value="null"
                                >
                                </v-checkbox>
                            </td>
                            <td>&nbsp;</td>
                            <td>
                                <v-text-field
                                    v-model="filters.ar_codart"
                                    type="text"
                                    placeholder="cerca..."
                                    clearable
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    v-model="filters.ar_descr"
                                    type="text"
                                    placeholder="cerca..."
                                    clearable
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    v-model="filters.bc_code"
                                    type="text"
                                    placeholder="cerca..."
                                    clearable
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    v-model="filters.ar_codforn"
                                    type="text"
                                    placeholder="cerca..."
                                    clearable
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    v-model="filters.acl_descla1"
                                    type="text"
                                    placeholder="cerca..."
                                    clearable
                                ></v-text-field>
                            </td>
                            <td>
                                <v-text-field
                                    v-model="filters.acl_descla2"
                                    type="text"
                                    placeholder="cerca..."
                                    clearable
                                ></v-text-field>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:item.foto="{ item }">
                        <div style="text-align: center">
                            <a
                                :href="getImagePath(item.ar_codart)"
                                _target="_blank"
                            >
                                <img
                                    height="100px"
                                    :src="getImagePath(item.ar_codart)"
                                    onerror="javascript: this.src='/no_image.jpg';"
                                />
                            </a>
                        </div>
                    </template>
                    <template
                        v-slot:item.data-table-select="{ isSelected, item }"
                    >
                        <v-checkbox
                            v-model="isSelected"
                            @change="selectedChange(item, isSelected)"
                        ></v-checkbox>
                    </template>
                    <template v-slot:item.ar_codart="{ item }">
                        <a
                            :href="'/product?id=' + item.ar_codart"
                            target="_blank"
                            >{{ item.ar_codart }}</a
                        >
                    </template>
                    <template v-slot:item.ar_descr="{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <span
                                    style="display: inline-block"
                                    v-bind="attrs"
                                    v-on="on"
                                    ><b>{{ item.ar_descr }}</b></span
                                >
                            </template>
                            <div><b>Shopify ID:</b> {{ item.shopify_id }}</div>
                        </v-tooltip>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                            v-if="item.shopify_id != null"
                            small
                            @click="deleteItem(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                    <template v-slot:item.ar_varianti="{ item }">
                        <div
                            v-if="item.ar_varianti"
                            v-html="writeVariants(item.ar_varianti)"
                        ></div>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<style lang="scss"></style>
<script>
import requests from "../../requests";
export default {
    name: "shopofy-product-list",
    data: () => {
        return {
            search: "",
            loading: false,
            formula_magica: "1",
            filters: {
                ar_codart: "",
                ar_descr: "",
                bc_code: "",
                acl_descla1: "",
                acl_descla2: "",
                ar_codforn: "",
                isSelected: null,
            },
            //headers: ,
            selected: [],
            productData: [],
            collectionData: [],
        };
    },

    computed: {
        headers() {
            return [
                { text: "Foto", value: "foto", sortable: false },
                //{ text: "ID", value: "shopify_id" },
                {
                    text: "Cod Articolo",
                    value: "ar_codart",
                    filter: (f) => {
                        if (!this.filters.ar_codart) return true;
                        return f.indexOf(this.filters.ar_codart) > -1;
                    },
                },
                {
                    text: "Desc",
                    value: "ar_descr",
                    filter: (f) => {
                        if (!this.filters.ar_descr) return true;
                        return (
                            f.indexOf(this.filters.ar_descr.toUpperCase()) > -1
                        );
                    },
                },
                {
                    text: "Barcode",
                    value: "bc_code",
                    filter: (f) => {
                        if (!this.filters.bc_code) return true;
                        return f == this.filters.bc_code;
                    },
                },
                {
                    text: "Cod Forn.",
                    value: "ar_codforn",
                    filter: (f) => {
                        if (!this.filters.ar_codforn) return true;
                        return f == this.filters.ar_codforn;
                    },
                },
                {
                    text: "Fam.",
                    value: "acl_descla1",
                    filter: (f) => {
                        if (!this.filters.acl_descla1) return true;
                        return (
                            f.indexOf(this.filters.acl_descla1.toUpperCase()) >
                            -1
                        );
                    },
                },
                {
                    text: "Sot Fam.",
                    value: "acl_descla2",
                    filter: (f) => {
                        if (!this.filters.acl_descla2) return true;
                        return (
                            f.indexOf(this.filters.acl_descla2.toUpperCase()) >
                            -1
                        );
                    },
                },
                {
                    text: "Giac Sede",
                    value: "xx_dissede",
                },
                {
                    text: "Giac Lucca",
                    value: "xx_dislucca",
                },
                {
                    text: "Min Ord",
                    value: "ar_minordinabile",
                },
                { text: "Varianti", value: "ar_varianti" },
                { text: "Prima Data", value: "xx_jac_primadatacm" },
                { text: "", value: "actions", sortable: false },
            ];
        },
    },
    mounted() {
        console.log("Shopify Product List Mounted.");
        this.getShopifyCollectionList();
        this.getShopifyProductList();
    },
    methods: {
        writeVariants(variants) {
            let splitted = variants.split(";");
            let dat = "";
            _.forEach(splitted, function (val) {
                dat += "- " + val + "<br />";
            });
            return dat;
        },

        getImagePath(id) {
            let normId = id.toString().replace("/", "_") + ".jpg";
            return "/images/catalog/lower/" + normId;
        },
        getShopifyProductList() {
            this.loading = true;
            requests.getShopifyProductList(this.formula_magica).then((res) => {
                _.forEach(res.data, (d) => {
                    if (d.linked == 1) this.selected.push(d);
                });
                this.productData = res.data;
                this.loading = false;
            });
        },
        getShopifyCollectionList() {
            requests.getShopifyCollectionList().then((res) => {
                this.collectionData = res;
            });
        },
        selectedChange(item, isSelected) {
            item.linked = isSelected;

            if (isSelected == 0) {
                this.selected.splice(_.findIndex(this.selected, item), 1);
            } else {
                this.selected.push(item);
            }

            requests.saveProductToList(item);
        },
        deleteItem(item) {
            let confirm = window.confirm(
                "Il prodotto verrà cancellato dallo store online, procedere?"
            );
            if (confirm) {
                requests.deleteProduct(item.shopify_id).then(() => {
                    this.getShopifyProductList();
                });
            }
        },

        onChangeFilters() {
            this.getShopifyProductList();
        },
        exportCSV() {
            requests.exportLinkedData();
        },
        selectedChangeFilter() {
            requests.getShopifyProductList(this.formula_magica).then((res) => {
                _.forEach(res.data, (d) => {
                    if (d.linked == 1) this.selected.push(d);
                });
                if (this.filters.isSelected == null) {
                    this.productData = res.data;
                } else {
                    this.productData = _.filter(res.data, {
                        linked: this.filters.isSelected,
                    });
                }
            });
        },
    },
};
</script>
